// extracted by mini-css-extract-plugin
export default {"header":"styles_header__jrO12","title":"styles_title__2MM4n"};